/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var getPlugin = require('./ts');

module.exports = {
    onSettingsInit: function ( app, callback ) {
        require('mag-gettext').load({
            name: window.core.environment.language || 'en',
            path: app.path + 'lang'

        }, function () {
            var gettext = require('mag-gettext').gettext,
                data;

            /*eslint max-len:0*/
            /*eslint no-useless-escape:0*/
            data = {
                sections: [
                    {
                        id: 'timeshift',
                        name: gettext('TimeShift'),
                        description: gettext('TimeShift allows you to record a channel program on the USB-stick by pressing the \"Pause\" button on your remote control. When you press the \"Pause\" button again, the recording will continue and the channel will start playing from the storage device starting at the point in the program where you first pressed \"Pause\".'),
                        icon: 'theme-icon-timeshift',
                        parent: 'system'
                    }
                ],
                options: [
                    // enable/disable
                    require('./options/enable')(app),

                    // display icon
                    // require('./options/display.icon')(app),

                    // path to record
                    // require('./options/path')(app),

                    // length
                    require('./options/length')(app),

                    // buffer mode
                    require('./options/buffer.mode')(app),

                    // on exit handler
                    require('./options/on.exit')(app),

                    // delay
                    require('./options/delay')(app)
                ]
            };
            callback(false, data);
        });

    },
    onAppInit: function ( app, callback ) {
        callback(null, getPlugin(app));
    }
};
